import { createSlice } from '@reduxjs/toolkit';

export interface AppState {
  appInitiated: boolean;
  firstPageShowEventCompleted: boolean;
}

const initialState: AppState = {
  appInitiated: false,
  firstPageShowEventCompleted: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    appInitiated: (state) => {
      state.appInitiated = true;
    },
    firstPageShowEventCompleted: (state) => {
      state.firstPageShowEventCompleted = true;
    },
  },
});

export const { appInitiated, firstPageShowEventCompleted } = appSlice.actions;

export default appSlice.reducer;
